import { render, staticRenderFns } from "./ModalPrompt.vue?vue&type=template&id=ad6f1918&"
import script from "./ModalPrompt.vue?vue&type=script&lang=js&"
export * from "./ModalPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports